import styled from 'styled-components'
import { GIVONIC, INTER } from "../../styles/fonts"
import { CRIMSON_500, GRAYSCALE_600 } from "../../styles/colors"

export const Container = (styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
`) as any // eslint-disable-line @typescript-eslint/no-explicit-any

export const CloseButtonContainer = (styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`) as any // eslint-disable-line @typescript-eslint/no-explicit-any

export const CrossButton = (styled.div`
  background-color: white;
  width: 36px;
  height: 36px;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`) as any // eslint-disable-line @typescript-eslint/no-explicit-any

export const IconContainer = (styled.div`
  margin-bottom: 18px;
`) as any // eslint-disable-line @typescript-eslint/no-explicit-any

export const Title = (styled.span`
  font-family: ${GIVONIC.black};
  color: ${CRIMSON_500};
  font-size: 18px;
`) as any // eslint-disable-line @typescript-eslint/no-explicit-any

export const Description = (styled.span`
  font-family: ${INTER.regular};
  color: ${GRAYSCALE_600};
  font-size: 13px;
`) as any // eslint-disable-line @typescript-eslint/no-explicit-any

export const ButtonContainer = (styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 0 0 12px 0;
`) as any // eslint-disable-line @typescript-eslint/no-explicit-any
